import React, { Component } from "react";
import PropTypes from "prop-types";
import DrupalPopup from "../../../../Epics/Grants/Pages/RecommendGrant/Component/Popup/DrupalPopup.js";

export default class RemovePopup extends Component {
  state = {
    showPopup: true
  };

  handleCancel = e => {
    this.setState({
      showPopup: !this.state.showPopup
    });
  };

  handleOk = data => {
    this.props.removeCharity(data.granteeOrgAliasId);
    this.props.einData(data.granteeOrgAliasId);
    this.setState({
      showPopup: false
    });
  };

  render() {
    const { showSavedCharityData, page, keyProperty } = this.props;

    const { showPopup } = this.state;
    return (
      <DrupalPopup
        alertId="remove-saved-charity"
        html={true}
        page={page}
        show={showPopup}
        defaultPrimaryLabel={"CONTINUE"}
        defaultTitle={"Remove Saved Charity"}
        defaultSecondaryLabel={"No, take me back"}
        keyProperty={keyProperty}
        defaultDescription={
          "<p>You will not view this charity in your saved list.<br /><br />\nDo you want to continue?</p>"
        }
        primaryCta={() => this.handleOk(showSavedCharityData)}
        secondaryCta={this.handleCancel}
      />
    );
  }
}
RemovePopup.propTypes = {
  einData: PropTypes.func,
  keyProperty: PropTypes.any,
  page: PropTypes.any,
  removeCharity: PropTypes.func,
  showSavedCharityData: PropTypes.any
};